import React from "react";
import DropdownComp from "../../components/dropdown/dropdown";
import { HeaderProps } from "../types/header.types";
import UserListComp from "./UserList.component";
import HelpTextComp from "../../components/helper/helptext.component";
import { useTranslation } from 'react-i18next';

const HeaderComp = (props: HeaderProps) => {
  const { t } = useTranslation();
    return (
      <header className="org-results-header">
        <div className="org-results-header_title">{`${t('Results Analytics')}`}</div>
        <span style={{margin: "0 10px"}}>
          {t('For')}
        </span>
        <UserListComp
        fetchUserList={props.fetchUserList}
        usersList={props.usersList}
        handleFilterChange={props.handleFilterChange}
        displayingPeriod = {props.displayingPeriod}
        item={props.forData}
        />
        <DropdownComp
        labelText={`${t("Showing")} `}
        defaultValue={props.displayingPeriod}
        options={props.filterOptions}
        onChange={props.handleFilterChange}
        wrapperClass="showingDropdown"
        />
        <div className="lastUpdatedOn">
          {props.daysleft} {t('left in quarter')}
        </div>
        {/* <HelpTextComp popUpClass="leftAlign">
          This report shows average OKR progress percentages for a point in time.
        </HelpTextComp> */}
      </header>
    );
}

export default HeaderComp;
